import { ApplicationLoanStatus } from "pages/application/applicationService";
import { parseToDate } from "utilities/date";

/** Celebration copy on funded loans — not an outstanding borrower action. */
export const LOAN_FUNDED_CONTEXTUAL_MESSAGE = "Congratulations!";

const TERMINAL_LOAN_STATUSES = new Set<ApplicationLoanStatus>(["funded", "expired"]);

export interface SidebarLoanSortable {
  readonly loanContextualMessage?: string;
  readonly status: ApplicationLoanStatus;
  readonly startedDate: string;
}

export const hasOutstandingBorrowerAction = (loanContextualMessage?: string): boolean => {
  const message = loanContextualMessage?.trim();
  return Boolean(message) && message !== LOAN_FUNDED_CONTEXTUAL_MESSAGE;
};

export const isTerminalLoanStatus = (status: ApplicationLoanStatus): boolean =>
  TERMINAL_LOAN_STATUSES.has(status);

const getStartedTime = (startedDate: string): number => parseToDate(startedDate)?.getTime() ?? 0;

const compareSidebarLoans = (left: SidebarLoanSortable, right: SidebarLoanSortable): number => {
  const actionDiff =
    Number(hasOutstandingBorrowerAction(right.loanContextualMessage)) -
    Number(hasOutstandingBorrowerAction(left.loanContextualMessage));
  if (actionDiff !== 0) {
    return actionDiff;
  }

  const lifecycleDiff = Number(isTerminalLoanStatus(left.status)) - Number(isTerminalLoanStatus(right.status));
  if (lifecycleDiff !== 0) {
    return lifecycleDiff;
  }

  return getStartedTime(right.startedDate) - getStartedTime(left.startedDate);
};

/**
 * Client-side sidebar LOAN sort (ADO-521155 / US-03).
 * Outstanding borrower action → in-processing before funded/closed/expired → recency.
 * Returns every loan; callers must not cap with `.slice(0, 5)`.
 */
export const sortSidebarLoans = <T extends SidebarLoanSortable>(loans: readonly T[]): T[] =>
  [...loans].sort(compareSidebarLoans);
